export default function PastaIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path
        fill="#D7E6F0"
        d="M10 19.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75Z"
      />
      <path
        fill="#A5C3DC"
        d="M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
      />
      <path
        fill="#FAA019"
        d="M10 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M7.813 9.336a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M7.813 8.71a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M7.813 8.086a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M7.813 7.46a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M12.188 9.336a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M12.188 8.71a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M12.188 8.086a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M12.188 7.46a1.25 1.25 0 1 0 0-2.499 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 8.75a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path fill="#FAA019" d="M10 8.125a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
      <path
        fill="#FFD23C"
        d="M10 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm-4.375 5.625a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M5.625 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M5.625 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M5.625 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M6.211 10.938a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M6.211 10.313a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M6.211 9.688a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm1.601 7.226a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M7.813 16.29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M7.813 15.664a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M7.813 15.04a1.25 1.25 0 1 0 0-2.501 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M6.211 15.313a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M6.211 14.688a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M6.211 14.063a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm5.976 2.851a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M12.188 16.29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M12.188 15.664a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M12.188 15.04a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 17.5a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M10 16.875a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 16.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm4.375-3.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M14.375 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M14.375 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#F57828"
        d="M14.375 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M13.789 15.313a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M13.789 14.688a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M13.789 14.063a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#FFD23C"
        d="M13.789 10.938a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M13.789 10.313a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M13.789 9.688a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#FAA019"
        d="M6.211 13.438a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM10 15.624a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.789-2.188a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0-4.374a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM10 6.874a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 11.25A3.125 3.125 0 1 0 10 5a3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M10 10.625a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 10a1.875 1.875 0 1 0 0-3.75A1.875 1.875 0 0 0 10 10Z"
      />
      <path
        fill="#FAA019"
        d="M10 9.375a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 15a3.125 3.125 0 1 0 0-6.25A3.125 3.125 0 0 0 10 15Z"
      />
      <path
        fill="#FAA019"
        d="M10 14.375a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M10 13.75A1.875 1.875 0 1 0 10 10a1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#FAA019"
        d="M10 13.125a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM6.211 9.062a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M8.125 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M8.125 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M8.125 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#FAA019"
        d="M8.125 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M8.125 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm3.75 2.5a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      />
      <path
        fill="#FAA019"
        d="M11.875 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      />
      <path
        fill="#FFD23C"
        d="M11.875 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
      />
      <path
        fill="#FAA019"
        d="M11.875 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
      <path
        fill="#FFD23C"
        d="M11.875 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Z"
      />
      <path
        fill="#5FAA46"
        d="M11.927 13.392a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.52-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-2.75.475a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.98-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.318 2.673a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.244-.596a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM7.75 13.23a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.1-.522a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm.475 2.751a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.1-.98a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .313Zm2.673.318a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.596 1.245a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Z"
      />
      <path
        fill="#F04B37"
        d="M10.938 6.354a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm3.958 2.396a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm-8.021.417a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm-1.563 3.438a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25ZM9.793 15a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm4.791-.938a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm-9.27-6.458a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm6.666 1.458a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Z"
      />
      <path
        fill="#5FAA46"
        d="M12.656 11.309a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.521-1.101a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-2.75.476a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.98-1.101a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.319 2.674a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.244-.597a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM9.323 8.22a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.52-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-2.75.475a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.98-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-.318 2.673a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313ZM6.51 8.57a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.563 4.301a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm.52-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-2.75.475a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm.98-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.318 2.673a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-1.245-.596a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm10.938-2.227a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.52-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-2.75.475a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.98-1.1a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.318 2.673a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-1.245-.596a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-.653-6.643a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-1.1-.52a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.475 2.75a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.1-.98a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm2.673.318a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-.596 1.245a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313ZM7.82 5a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-1.1-.52a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm.475 2.75a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-1.1-.98a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm2.673.318a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM8.17 7.813a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Z"
      />
      <path
        fill="#D7E6F0"
        d="M12.974 7.188a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.335.843a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-1.307-1.925a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-2.067 1.68a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-.996-.58a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM9.5 6.277a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-2.133 5.164a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM5.99 10.91a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.03-2.114a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm5.345 3.13a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .313Zm-1.97-1.07a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .313Zm.323-1.579a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm3.522 1.9a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-2.022-1.387a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.723-.78a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-5.956 4.949a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-.946-.596a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.807-2.234a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm2.2 2.722a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.265-.99a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.598.21a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-.894-6.884a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.335.842a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM9.373 5.104a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM7.307 6.782a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm-.997-.578a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm2.232-.929a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312ZM6.409 10.44a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313ZM5.03 9.907a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.03-2.115a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm5.346 3.132a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-1.97-1.07a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.322-1.58a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm3.522 1.9a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313ZM11.26 8.787a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.723-.78a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm-5.957 4.95a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Zm-.946-.597a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.807-2.234a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm2.2 2.722a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .313Zm.265-.99a.156.156 0 1 0 0-.312.156.156 0 0 0 0 .312Zm1.598.21a.156.156 0 1 0 0-.313.156.156 0 0 0 0 .312Z"
      />
      <path
        fill="#69A041"
        d="m10.514 8.198-.293-.294a.313.313 0 0 0-.442 0l-.294.294a1.435 1.435 0 0 0-.422 1.02c0 .386.15.75.423 1.022l.293.293a.312.312 0 0 0 .442 0l.294-.293c.272-.273.423-.636.423-1.021 0-.386-.15-.749-.423-1.021Z"
      />
      <path
        fill="#4B8C41"
        d="m12.721 10.404-.294-.293a1.435 1.435 0 0 0-1.02-.424c-.387 0-.75.15-1.022.424l-.293.293a.313.313 0 0 0 0 .442l.293.293c.273.273.635.424 1.021.424.386 0 .749-.15 1.021-.424l.294-.293a.313.313 0 0 0 0-.442Z"
      />
      <path
        fill="#4B8C41"
        d="m9.908 10.404-.293-.293a1.435 1.435 0 0 0-1.021-.424c-.386 0-.749.15-1.021.424l-.294.293a.313.313 0 0 0 0 .442l.294.293c.272.273.635.424 1.02.424.387 0 .75-.15 1.022-.424l.293-.293a.313.313 0 0 0 0-.442Z"
      />
      <path
        fill="#4B8C41"
        d="M10 11.875a.312.312 0 0 1-.313-.313v-.937h.626v.938c0 .172-.14.312-.313.312Z"
      />
    </svg>
  );
}
